import { z } from 'zod';
import { BrandCodeSchema, ProductLineSchema } from './mix';

export const PaletteInputSchema = z.object({
	id: z.string().optional(),
	paletteName: z.string(),
	colors: z.array(z.string()).nullable(),
	brandCode: BrandCodeSchema,
	srcProductLine: ProductLineSchema.optional(), // if undefined, it's assumed to be heavy-body for acrylics and oil colors for wb
});

export type PaletteInputType = z.infer<typeof PaletteInputSchema>;

export const PaletteOutputSchema = z.object({
	id: z.string(),
	paletteName: z.string(),
	colors: z.array(z.string()),
	brandCode: BrandCodeSchema,
	srcProductLine: ProductLineSchema,
	paletteFullPublicId: z.string().optional(),
	palettePublicName: z.string().optional(),
	createdDate: z.iso.datetime(),
});

export type PaletteOutputType = z.infer<typeof PaletteOutputSchema>;

export const SharePaletteInputSchema = z.object({
	palettePublicName: z.string(),
	userPublicName: z.string().optional(),
	setUserPublicName: z.boolean(),
});

export type SharePaletteInputType = z.infer<typeof SharePaletteInputSchema>;

export const PostSharePaletteInputSchema = z.object({
	json: z.string().transform((data) => {
		try {
			return SharePaletteInputSchema.parse(JSON.parse(data));
		} catch (_e) {
			throw new Error('Invalid JSON structure');
		}
	}),
	image: z.any().refine((file) => file instanceof Blob, { message: 'Invalid file format' }),
});

export const SharedPaletteOutputSchema = PaletteOutputSchema.extend({
	paletteFullPublicId: z.string(),
	palettePublicName: z.string(),
	userPublicId: z.string(),
	userPublicName: z.string(),
	userNameChanged: z.boolean(),
});

export type SharedPaletteOutputType = z.infer<typeof SharedPaletteOutputSchema>;
